// @ts-strict-ignore
import React, { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'

interface InputProps {
  type: string
  value: number
  onChange: Function
  name: string
  prefix?: string
  suffix?: string
  format?: string
  error?: boolean
}

const Input = ({
  type,
  value,
  onChange,
  name,
  prefix,
  suffix,
  format,
  error = false,
}: InputProps) => {
  const formatString = (str: string) => {
    if (type === 'text' && format !== 'thousands') {
      return str
    }
    const s = str.replace(/[^0-9]/g, '')
    return format === 'thousands' ? s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : s
  }
  const toInteger = (v) =>
    format === 'thousands'
      ? parseInt(v.replace(/[^0-9]/g, ''))
      : type === 'number'
      ? parseInt(v)
      : v

  const toString = useCallback(
    (v: number) => {
      const s = v.toString()
      return format === 'thousands' ? s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : s
    },
    [format],
  )

  const [valueString, setValueString] = useState(toString(value))

  useEffect(() => {
    setValueString(toString(value))
  }, [value, toString])

  const handleChange = (e) => {
    setValueString(formatString(e.target.value))
    onChange({
      ...e,
      target: {
        ...e.target,
        value: toInteger(e.target.value),
      },
    })
  }

  return (
    <div className='Platinum-input-wrapper'>
      {prefix && <span className='Platinum-input-prefix'>{prefix}</span>}
      <input
        name={name}
        data-format={format}
        data-calculator-value={valueString}
        type={type}
        onChange={handleChange}
        value={valueString}
        className={classNames('Platinum-input', {
          'Platinum-input-prefix-space': prefix,
          'Platinum-input-suffix-space': suffix,
          'Platinum-input__error': error,
        })}
      />
      {suffix && <span className='Platinum-input-suffix'>{suffix}</span>}
    </div>
  )
}

export default Input
